<script setup>
import { ref } from "vue";
import fetchData from "@/utils/fetchData";
import StatCard from "./StatCard.vue";
import { cents, decimal, percent } from "@/utils/format";

// Each figure shows "–" until it arrives
const stats = ref({});
const load = (endpoint, pick) =>
  fetchData(endpoint).then((data) => {
    stats.value = { ...stats.value, ...pick(data) };
  });

load("getPercentagePositive", (data) => ({ positive: data.percentage }));
load("getPercentageReturn", (data) => ({ returning: data.percentage }));
load("getAverageReturns", (data) => ({ returns: data.averageReturns }));
load("getAverageQuestionsAnswered", (data) => ({
  answers: data.averageAnswers,
}));
load("getAverageGenerations", (data) => ({
  generations: data.countOfGenerations,
}));
load("getAverageCost", (data) => ({ cost: data.countOfCosts }));
// The API gives a share from 0 to 1
load("getAverageCached", (data) => ({ cached: data.cachedPercent * 100 }));

const show = (key, format) =>
  stats.value[key] === undefined ? "–" : format(stats.value[key]);
</script>

<template>
  <section class="container mx-auto px-4 py-3">
    <h2 class="section-title mb-3">How people use it</h2>
    <div class="grid grid-cols-2 gap-4 lg:grid-cols-4">
      <StatCard
        title="Positive ratings"
        :total="show('positive', percent)"
        extra-text="Of the makes people rated"
      />
      <StatCard
        title="People who come back"
        :total="show('returning', percent)"
        extra-text="8 hours or more after they start"
      />
      <StatCard
        title="Returns per person"
        :total="show('returns', (value) => decimal(value, 1))"
        extra-text="On average, 8 hours or more apart"
      />
      <StatCard
        title="Questions answered"
        :total="show('answers', (value) => decimal(value, 1))"
        extra-text="Per make, on average"
      />
    </div>
    <h2 class="section-title mb-3 mt-6">Each make</h2>
    <div class="grid grid-cols-2 gap-4 lg:grid-cols-3">
      <StatCard
        title="Generations per make"
        :total="show('generations', (value) => decimal(value, 1))"
        extra-text="On average, counting re-makes"
      />
      <StatCard
        title="AI cost per make"
        :total="show('cost', cents)"
        extra-text="On average, every step included"
      />
      <StatCard
        class="col-span-2 lg:col-span-1"
        title="Answered from the cache"
        :total="show('cached', percent)"
        extra-text="Questions, styles and formats, never the make itself"
      />
    </div>
  </section>
</template>
